import { atom } from 'recoil'

export const searchState = atom({
  key: 'smtpplusListSearchState',
  default: {
    searchText: '',
    filterByField: 'LastUpdated',
    filterByFieldFrom: undefined,
    filterByFieldTo: undefined,
    orderBy: 'LastUpdated',
    orderDesc: true,
    pageNumber: 1,
    pageSize: 10
  }
})
